import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Main = styled.main`
  width: 100%;
  padding: 16px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  row-gap: 12px;
  column-gap: 12px;
  grid-template-areas:
    'purpleMetrics'
    'prevAbastecimento'
    'ctos'
    'minhasSolicitacoes'
    'historicoConsumo';

  @media (min-width: 769px) {
    padding: 35px;
    grid-template-columns: 43% 57%;
    column-gap: 16px;
    row-gap: 16px;
    grid-template-areas:
      'purpleMetrics purpleMetrics'
      'prevAbastecimento prevAbastecimento'
      'ctos minhasSolicitacoes'
      'historicoConsumo historicoConsumo'
      'consumptionHistory consumptionHistory';
  }
`;

type TourWrapProps = {
  $showTour?: boolean;
};

export const TourWrap = styled('div', {
  shouldForwardProp: (prop) => prop !== '$showTour',
})<TourWrapProps>`
  position: relative;

  ${({ $showTour }) =>
    $showTour &&
    css`
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px;
      border-radius: 8px;
    `}
`;

export const PrevAbastecimentoWrap = styled(TourWrap)`
  grid-area: prevAbastecimento;
`;

export const PurpleMetricsWrap = styled(TourWrap)`
  grid-area: purpleMetrics;
`;

export const HistoryWrap = styled(TourWrap)`
  grid-area: historicoConsumo;
`;

export const CtosWrap = styled(TourWrap)`
  grid-area: ctos;
  display: flex;
  flex-direction: column;
  height: 100%;

  > * {
    flex: 1;
    min-height: 0;
  }
`;

export const SolicitationsWrap = styled(TourWrap)`
  grid-area: minhasSolicitacoes;
`;

export const ImageBannerPurpleMetrics = styled.img`
  display: block;
  border-radius: 8px;
  width: 100%;
  height: 62px;
  cursor: pointer;
  pointer-events: auto;

  @media (min-width: 621px) {
    height: 98px;
  }
`;

export const LinkPurpleMetrics = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus {
    cursor: pointer;
  }

  &:focus-visible {
    outline: 2px solid #0b29fb;
    outline-offset: 2px;
  }
`;
